var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntertainment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 45",
    style: {
      enableBackground: "new 0 0 45 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#827F83;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.5,45C34.9,45,45,34.9,45,22.5S34.9,0,22.5,0S0,10.1,0,22.5S10.1,45,22.5,45z M14.4,30.5 c0.6-0.8,1.6-0.9,2.4-0.4c1.6,1.2,3.6,1.9,5.8,1.9s4.1-0.7,5.8-1.9c0.8-0.6,1.8-0.4,2.4,0.4c0.6,0.8,0.4,1.8-0.4,2.4 c-2.2,1.6-4.9,2.6-7.8,2.6s-5.6-1-7.8-2.6C14,32.3,13.9,31.2,14.4,30.5L14.4,30.5z M31.5,19.1c0,1.9-1,3.4-2.2,3.4S27,21,27,19.1 s1-3.4,2.2-3.4S31.5,17.3,31.5,19.1z M15.8,22.5c1.2,0,2.2-1.5,2.2-3.4s-1-3.4-2.2-3.4s-2.2,1.5-2.2,3.4S14.5,22.5,15.8,22.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntertainment);
export default __webpack_public_path__ + "static/media/entertainment.5e9393d1d5dd6c11ca8b68dff6dbf7d0.svg";
export { ForwardRef as ReactComponent };